import { Outlet, Navigate, useParams } from 'react-router-dom';
import { useUserProfile } from '../api/userInfo';
import LoginPage from '../view/authentication/Login';
import SiteMainPage from '../view/management/site/SiteMainPage';
import PageLayout from 'src/components/layout/PageLayout';
import { WidgetLoading } from 'src/components/ui';
import { BACKGROUND_VIDEO } from 'src/shared/config';
import { useMsal } from '@azure/msal-react';

const ProtectedRoutes = () => {
    const { instance, accounts, inProgress } = useMsal();
    const { userProfile, isLoadingUserProfile, isErrorUserProfile } = useUserProfile();
    const { lang } = useParams();

    if (isLoadingUserProfile || inProgress === "login") return <div className="fixed flex items-center justify-center w-screen h-screen bg-white"><WidgetLoading text={'Please wait...'} /></div>
    
    if(!userProfile) return <Navigate to={`/${lang}/login`}/> 
    if (userProfile && !userProfile?.is_verified_email) return <Navigate to={`/${lang}/verify`}/>

    return <Outlet />
}

// this is just an example, we can have many types of routes
const SuperUserRoutes = () => {
    // check if they have permission to access this route
    // check if they selected a company (and they have access to it)
    // check if they have a valid subscription
    // and many more
  
}
export  {ProtectedRoutes,SuperUserRoutes};

